import { Loadable } from '../../Loadable';

export const AsyncEvents = Loadable(() => import('./Events'));
